<template>
  <el-form ref="form" :model="form" :rules="formRules" class="form_flex">
    <el-form-item prop="status">
      <el-select
        class="search-select"
        v-model="form.roleName"
        placeholder="请选择状态"
        @change="changeRole"
      >
        <el-option
          v-for="(item, index) in rolesList"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item prop="phoneNumber" style="marin: 0 10px">
      <el-input
        class="search-input"
        v-model="form.phoneNumber"
        placeholder="请输入手机号码"
      ></el-input>
    </el-form-item> -->
    <el-form-item prop="userName">
      <el-select
        class="select"
        v-model="form.userName"
        filterable
        remote
        placeholder="请输入用户名"
        :remote-method="searchUser"
        @change="checkItem"
        clearable
        :loading="loading"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item prop="message">
      <el-input
        v-model="form.message"
        autocomplete="off"
        class="msg-input"
        placeholder="给用户发送信息输入框"
      />
    </el-form-item>

    <el-form-item class="btn">
      <el-button
        size="small"
        icon="el-icon-plus"
        @click="sendMsg"
        type="primary"
        v-if="roleList[path].includes('_Add')"
        >发送消息</el-button
      >
      <el-button @click="onSearch" icon="el-icon-search" size="small"
        >查询</el-button
      >
      <el-button size="small" @click="resetForm">清空</el-button>
      <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
        >刷新</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex';
import { getUserModelApi } from '@/api/user.js';
import { sendMyMsgApi } from '@/api/newsApi.js';
import { decrypt } from '@/utils/encryp';
export default {
  name: 'MessageSearchBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  data() {
    return {
      // 表单内容
      form: {
        status: '',
        phoneNumber: '',
        userId: '',
        message: '',
        userName: '',
        roleName: '',
      },
      path: '',
      formRules: {
        status: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
        userName: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
        ],
      },
      rolesList: [
        { label: '编辑中', value: 1 },
        { label: '已发布', value: 2 },
        { label: '已删除', value: 3 },
      ],
      options: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  methods: {
    // 搜索，触发父组件请求数据的方法
    async onSearch() {
      this.$emit('search', {
        status: this.form.status,
        userId: this.form.userId,
        phoneNumber: this.form.phoneNumber,
      });
    },

    // 搜索用户名
    async searchUser(val) {
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.options = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 选择用户名下拉选项
    checkItem(val) {
      this.form.userId = val;
    },

    // 点击状态下拉数据
    changeRole(val) {
      this.form.status = val;
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 给用户发送消息
    sendMsg() {
      this.$refs.form.validate(async (valid) => {
        if (!valid || this.form.message.trim() === '')
          return this.$message.error('请检查是否填写完整');
        // console.log(
        //   '现在时间：',
        //   Date.now(),
        //   this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        // );
        let nowTime = this.$moment(Date.now()).format('YYYY-MM-DD HH:mm:ss');
        const areaId = localStorage.getItem('areaId')
          ? JSON.parse(localStorage.getItem('areaId')).areaId
          : '';
        let data =
          'userId=' +
          this.form.userId +
          '&status=' +
          this.form.status +
          '&phoneNumber=' +
          this.form.phoneNumber +
          '&message=' +
          this.form.message +
          '&sendTime=' +
          nowTime +
          '&areaId=' +
          areaId;
        let res = await sendMyMsgApi(data);
        if (res.code !== 200) return;
        this.$message.success('发送成功!');
        // 清空表单
        this.$refs['form'].resetFields();
        // 重新请求数据
        this.$emit('search');
      });
    },

    // 清空表单
    resetForm() {
      this.form = {};
      this.$refs['form'].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-select {
  width: 120px;
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

.msg-input {
  width: 330px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
